import React, { PureComponent } from 'react';
import {
    Text,
    TextInput,
    TouchableOpacity,
    View,
    Switch,
    Image,
    ScrollView,
    Keyboard
} from 'react-native-web';
import PropTypes from 'prop-types';
import moment from 'moment';
import * as Animatable from 'react-native-animatable';

// Custom Components
import LoadingView from '../../components/component_loading_view';
import { Button, InScreenModal, NavBar, SectionTitle } from '../../components';

// APIs
import {
    createFoodModifier,
    deleteFoodModifier,
    editFoodModifier
} from '../../modules';

// Utils
import { showAlert, showAppError } from '../../utils/util_helpers';
import { toast, Toaster } from 'react-hot-toast';

// Configs
import GLOBAL from '../../configs/config_global';

export default class ModifierModal extends PureComponent {
    // region Props
    static propTypes = {
        truckData: PropTypes.object,
        showModifierModal: PropTypes.bool,
        onModifierModalDismissed: PropTypes.func,
        foodItemData: PropTypes.object,
        onModifierGroupCreated: PropTypes.func,
        onModifierGroupUpdated: PropTypes.func,
        onModifierGroupRemoved: PropTypes.func,
        categoryData: PropTypes.object,
        modifierGroupNameList: PropTypes.array
    };

    static defaultProps = {
        truckData: {},
        showModifierModal: false,
        onModifierModalDismissed: () => {},
        onModifierGroupCreated: () => {},
        foodItemData: {},
        onModifierGroupUpdated: () => {},
        onModifierGroupRemoved: () => {},
        categoryData: {},
        modifierGroupNameList: []
    };
    // endregion

    // region Constructor
    constructor(props) {
        super(props);
        this.idEdit = false;
    }

    state = {
        startLoadingComp: false,
        isLoading: false,

        name: '',
        allowMultiple: false,
        maxSelect: 0,
        mustSelect: false,
        minSelect: 1,

        modifierList: [],

        currentModifierID: -1,
        currentModifierName: '',
        currentModifierPrice: '',

        isNameFocused: false,

        showList: false,
        showModal: false,
        currentModifierGroup: {}
    };
    // endregion

    // region Function - Initialize Values
    initializeValue() {
        // Set initial data
        this.setState({
            name: this.state.currentModifierGroup?.name || '',
            allowMultiple: this.state.currentModifierGroup?.['type'] === 1 || false,
            maxSelect: this.state.currentModifierGroup?.['max_select'] || 0,
            mustSelect: this.state.currentModifierGroup?.['must_select'] === 1 || false,
            minSelect: this.state.currentModifierGroup?.['min_select'] || 1,

            modifierList: (this.state.currentModifierGroup?.items || []).concat({ id: -1 }),

            currentModifierID: -1,
            currentModifierName: '',
            currentModifierPrice: ''
        }, () => this.setState({ startLoadingComp: true }));
    }
    // endregion

    // region Function - Add Modifier
    addModifier(name = '', price = '') {
        this.checkDuplicateName(name, () => {
            if (!name.trim() || !price.trim()) return;

            let newModifierItem = { name, price, id: `modifier_${moment().unix()}`, type: 0 },
                tempArr = [].concat(this.state.modifierList);

            tempArr.splice(this.state.modifierList.length - 1, 0, newModifierItem);

            this.setState({
                modifierList: tempArr,
                currentModifierName: '',
                currentModifierPrice: '',
                currentModifierID: -1
            }, () => {
                if (this[`modifierItem_-1_name`]) this[`modifierItem_-1_name`].focus();
            });
        });
    }
    // endregion

    // region Function - Edit Modifier
    editModifier(modifierID = -1, name = '', price = '') {
        if (!name.trim() || !price.trim()) return;

        let tempArr = [].concat(this.state.modifierList),
            modifierIndex = tempArr.findIndex((item) => item.id === modifierID),
            updatedModifierItem = Object.assign({}, tempArr[modifierIndex], { name, price });

        tempArr.splice(modifierIndex, 1, updatedModifierItem);

        this.setState({
            modifierList: tempArr,
            currentModifierName: '',
            currentModifierPrice: '',
            currentModifierID: -1
        }, () => {
            if (this[`modifierItem_${tempArr[modifierIndex + 1].id}_name`]) this[`modifierItem_${tempArr[modifierIndex + 1].id}_name`].focus();
            console.log(`Modifier Item Updated (Index: ${modifierIndex})`, this.state.modifierList);
        });
    }
    // endregion

    // region Function - Remove Modifier
    removeModifier(modifierID = null, index) {
        let tempArr = [].concat(this.state.modifierList),
            modifierIndex = !modifierID ? index : tempArr.findIndex((item) => item.id === modifierID),
            tempItem = Object.assign({}, tempArr[modifierIndex], { is_remove: true }),
            isNewModifier = !modifierID || modifierID.toString().includes('modifier');

        if (isNewModifier) {
            tempArr.splice(modifierIndex, 1);
        }
        else tempArr.splice(modifierIndex, 1, tempItem);

        this.setState({ modifierList: tempArr }, () => {
            if (isNewModifier) this.toast.show(`Removed "${tempItem.name}" from the group`, 2000);
        });
    }
    // endregion

    // region Function - Remove Modifier
    restoreModifier(modifierID = -1) {
        if (modifierID === -1) return;

        let tempArr = [].concat(this.state.modifierList),
            modifierIndex = tempArr.findIndex((item) => item.id === modifierID);

        if (modifierIndex > -1) delete tempArr[modifierIndex]['is_remove'];

        this.setState({ modifierList: tempArr }, () => {
            console.log(`Modifier Item Updated (Index: ${modifierIndex})`, this.state.modifierList);
        });
    }
    // endregion

    // region Function - Create Modifier Group
    goSubmitModifierList() {
        Keyboard.dismiss();

        if (!this.state.name.trim()) {
            showAlert({ text: 'Please enter a name for your modifier group' });
            return;
        }

        if (this.props.modifierGroupNameList.filter((group) => this.isEdit ? (group.id !== this.state.currentModifierGroup?.id) : true).includes(this.state.name.trim().toLowerCase())) {
            showAlert({ text: 'This modifier group name already exists, please choose another name' });
            return;
        }

        let finalModifierList = this.state.modifierList.filter((item) => item.id !== -1),
            modifierData = {
                id: this.state.currentModifierGroup?.id || `modifierGroup_${moment().unix()}`,
                name: this.state.name,
                type: this.state.allowMultiple ? 1 : 0,
                must_select: this.state.mustSelect ? 1 : 0,
                items: finalModifierList.map((item) => {
                    const newItem = Object.assign({}, item);
                    if (newItem['is_remove']) {
                        // If this is a removing item
                        Object.keys(item).forEach((key) => {
                            if (key !== 'is_remove' && key !== 'id') delete newItem[key];
                        });
                    }
                    else {
                        // If this is a newly created item
                        if (this.isEdit && item?.id?.toString().includes('modifier')) delete newItem.id;
                    }

                    return newItem;
                })
            };

        // Push max_select and min_select
        if (this.state.allowMultiple) modifierData['max_select'] = this.state.maxSelect;
        if (this.state.mustSelect) modifierData['min_select'] = this.state.minSelect;

        // Check if modifier is empty
        if (finalModifierList.length === 0) {
            showAlert({ text: 'Please have at least one modifier item in the list to continue' });
            return;
        }

        // Generate confirm message
        let confirmMessage = this.isEdit ?
            `Confirm updating this modifier group with new data?`
            :
            `Confirm creating new modifier group named "${this.state.name}" with total ${finalModifierList.length} item${finalModifierList.length > 1 ? 's' : ''}?`;

        // If modifier group was created during food item creation, no need to ask first
        if (!this.props.foodItemData?.id) {
            if (this.isEdit) {
                this.props.onModifierGroupUpdated(modifierData, true);
            }
            else this.props.onModifierGroupCreated(modifierData, true);
        }
        else {
            showAlert({
                text: confirmMessage,
                cancelButton: { text: 'Cancel' },
                confirmButton: {
                    text: 'Confirm',
                    color: GLOBAL.COLOR.MAIN,
                    onPress: () => {
                        const apiCall = this.isEdit ?
                            editFoodModifier(this.props.truckData.id, this.props.categoryData.id, this.props.foodItemData.id, modifierData)
                            :
                            createFoodModifier(this.props.truckData.id, this.props.categoryData.id, this.props.foodItemData.id, modifierData);

                        // Call API
                        this.setState({ isLoading: true });
                        apiCall
                            .then((result) => {
                                this.setState({ isLoading: false });

                                if (this.isEdit) {
                                    this.props.onModifierGroupUpdated(result['modifiers'].find((item) => item.id === this.state.currentModifierGroup.id));
                                }
                                else this.props.onModifierGroupCreated(result['modifiers'].pop());
                            })
                            .catch((error) => {
                                this.setState({ isLoading: false });
                                showAppError(error);
                            });
                    }
                }
            })
        }
    }
    // endregion

    // region Function - Delete Modifier Group
    goDeleteModifierGroup() {
        showAlert({
            text: 'Are you sure you want to delete this modifier group? This action cannot be undone.',
            cancelButton: { text: 'Cancel' },
            confirmButton: {
                text: 'Confirm',
                color: GLOBAL.COLOR.MAIN,
                onPress: () => {
                    if (this.state.currentModifierGroup.id.toString().includes('modifier')) {
                        this.props.onModifierGroupRemoved(this.state.currentModifierGroup.id, true);
                    }
                    else {
                        this.setState({ isLoading: true });
                        deleteFoodModifier(this.props.truckData.id, this.props.categoryData.id, this.props.foodItemData.id, this.state.currentModifierGroup.id)
                            .then(() => {
                                const name = this.state.currentModifierGroup.name;
                                this.setState({ isLoading: false });
                                this.props.onModifierGroupRemoved(this.state.currentModifierGroup.id);
                                setTimeout(() => toast(`Successfully deleted modifier group "${name}"`), 500);
                            })
                            .catch((error) => {
                                this.setState({ isLoading: false });
                                showAppError(error);
                            });
                    }
                }
            }
        });
    }
    // endregion

    // region Function -  On Must Select Switch
    _onMustSelectSwitch = (value, isEdit) => {
        const cancelFunc = () => {
            if (isEdit) return;
            this.setState({ mustSelect: false, minSelect: 1 });
        };

        if (value) {
            this.setState({ mustSelect: true });

            const message = `Enter the minimum amount of modifiers that consumers must select for this group`;
            const confirmFunc = (number) => {
                const amount = Number(number);
                this.setState(
                    Object.assign(
                        {
                            mustSelect: true,
                            minSelect: amount
                        },
                        amount > 1 ?
                            (
                                this.state.maxSelect < amount ?
                                    {
                                        allowMultiple: true,
                                        maxSelect: amount
                                    }
                                    :
                                    {}
                            )
                            :
                            {}
                    )
                );
            };

            showAlert({
                text: message,
                showTextInput: true,
                inputConfigs: { placeholder: 'Min Value', defaultValue: this.state.minSelect.toString() },
                cancelButton: {
                    text: 'Cancel',
                    onPress: cancelFunc
                },
                confirmButton: {
                    text: 'Confirm',
                    color: GLOBAL.COLOR.MAIN,
                    onPress: confirmFunc
                }
            });
        }
        else cancelFunc();
    };
    // endregion

    // region Function -  On Allow Multiple Switch
    _onMultipleSelectSwitch = (value, isEdit) => {
        if (!value && this.state.mustSelect && this.state.minSelect > 1) {
            showAlert({ text: `You have set the minimum amount that customers must select to be ${this.state.minSelect}, cannot turn off multiple selections` });
            return;
        }

        const cancelFunc = () => {
            if (isEdit) return;
            this.setState({ allowMultiple: false, maxSelect: 0 });
        };

        if (value) {
            this.setState({ allowMultiple: true });
            const minSelect = this.state.minSelect || 1;
            const message = `Enter the maximum amount of modifiers that consumers can select for this group, must be larger than ${minSelect}<br/>(enter 0 for unlimited)`;
            const confirmFunc = (number) => {
                if (Number(number) >= minSelect || Number(number) === 0) {
                    this.setState({ allowMultiple: true, maxSelect: Number(number) });
                }
                else {
                    showAlert({
                        text: `The minimum amount you must enter is ${minSelect}`,
                        confirmButton: {
                            text: 'OK',
                            color: GLOBAL.COLOR.TEXT_LIGHT_GRAY,
                            onPress: () => this._onMultipleSelectSwitch(true, true)
                        }
                    });
                }
            };

            showAlert({
                text: message,
                showTextInput: true,
                inputConfigs: { placeholder: 'Max Value', defaultValue: this.state.maxSelect.toString() },
                cancelButton: {
                    text: 'Cancel',
                    onPress: cancelFunc
                },
                confirmButton: {
                    text: 'Confirm',
                    color: GLOBAL.COLOR.MAIN,
                    onPress: confirmFunc
                }
            });
        }
        else cancelFunc();
    };
    // endregion

    // region Render Nav Bar
    renderNavBar() {
        const { foodItemData } = this.props;

        return(
            <NavBar
                title={this.state.startLoadingComp ? ((this.isEdit ? 'Edit' : 'New') + ' Modifier Group') : ''}
                subTitle={this.state.startLoadingComp ? (foodItemData ? `for "${foodItemData.name || 'New Item'}"` : '') : ''}
                ignoreTopBarHeight={true}
                leftButtonTitle={'Cancel'}
                horizontalSpacing={16}
                leftButtonOnPress={this.hideModal}
                rightButtonTitle={this.state.startLoadingComp ? 'Done' : ''}
                rightButtonOnPress={() => this.goSubmitModifierList()}
            />
        );
    }
    // endregion

    // region Render Switch Setting
    renderSwitchView(name, value = false, onSwitch = () => {}, helpText = '', textOnPress = () => {}, customContainerStyle = {}, customTextStyle = {}, disabled = false) {
        return(
            <View style={[{ alignSelf: 'stretch', flexDirection: 'row', alignItems: 'center', borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER, padding: 24 }, customContainerStyle]}>
                {/* Text */}
                <TouchableOpacity onPress={textOnPress} disabled={!value}>
                    <Text style={[{ color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontSize: 18 }, customTextStyle]}>
                        {name}
                    </Text>
                </TouchableOpacity>

                {/* Help Button */}
                <TouchableOpacity
                    style={{ marginLeft: 8 }}
                    onPress={() => showAlert({ text: helpText })}>
                    <Image
                        source={require('../../images/iconLineHelp.png')}
                        style={{ width: 20, height: 20 }}
                    />
                </TouchableOpacity>

                {/* Blank Space */}
                <View style={{ flex: 1 }}/>

                {/* Mode Switch */}
                <Switch
                    value={value}
                    trackColor={'#DEDEDE'}
                    activeTrackColor={GLOBAL.COLOR.BASIC.UI_GREEN}
                    activeThumbColor={'white'}
                    thumbColor={'white'}
                    onValueChange={(switchValue) => onSwitch(switchValue)}
                />

                {/* Disable View */}
                {
                    disabled &&
                    <View style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.7)' }}/>
                }
            </View>
        );
    }
    // endregion

    // region Render Name Input
    renderNameInput() {
        return(
            <View
                style={{
                    flexDirection: 'row', alignItems: 'center',
                    width: '100%', backgroundColor: 'white', paddingHorizontal: 24, paddingVertical: 16,
                    borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER
                }}>
                {/* Input */}
                <TextInput
                    ref={(comp) => (this.txtName = comp)}
                    placeholder={'Modifier Group Name'}
                    placeholderTextColor={'rgba(0, 0, 0, 0.1)'}
                    multiline={false}
                    returnKeyType={'go'}
                    autoCapitalize={'words'}
                    blurOnSubmit={true}
                    style={{ outlineStyle: 'none', fontSize: 26, fontWeight: '900', flex: 1, color: GLOBAL.COLOR.BASIC.BLACK_TWO }}
                    onChangeText={(text) => this.setState({ name: text })}
                    value={this.state.name}
                    onSubmitEditing={() => Keyboard.dismiss()}
                    underlineColorAndroid={'transparent'}
                    onFocus={() => this.setState({ isNameFocused: true })}
                    onBlur={() => this.setState({ isNameFocused: false })}
                />
            </View>
        );
    }
    // endregion

    // region Render Modifier Item

    // region Function - On Text Box Focused
    _onTextBoxFocused = (item) => {
        if (this.state.currentModifierID !== item.id) {
            this.setState(Object.assign({ currentModifierID: item.id }, item.id === -1 ? {} : { currentModifierName: item.name || '', currentModifierPrice: item.price || '' }));
        }
    };
    // endregion

    // region Function -  Is Item Multiple
    isItemMultiple = (modifierID) => {
        let modifierItem = this.state.modifierList.find((item) => item.id === modifierID);
        return(modifierItem?.type === 1 || false);
    };
    // endregion

    // region Function -  On Must Select Switch
    _onItemMultipleSwitch = (value, modifierID) => {
        let tempArr = [].concat(this.state.modifierList),
            modifierIndex = tempArr.findIndex((item) => item.id === modifierID),
            updatedModifierItem = Object.assign({}, tempArr[modifierIndex], { type: value ? 1 : 0 });

        tempArr.splice(modifierIndex, 1, updatedModifierItem);

        this.setState({ modifierList: tempArr }, () => console.log(`Modifier Item Updated (Index: ${modifierIndex})`, this.state.modifierList));
    };
    // endregion

    checkDuplicateName(modifier, goFunc = () => {}) {
        if (this.state.modifierList.find((modifierItem) => modifierItem.id !== -1 && modifierItem.name.trim().toLowerCase() === modifier.trim().toLowerCase())) {
            showAlert({ text: 'This modifier name already exists, please choose another name' });
            return;
        }

        goFunc();
    }

    // region Render Multiple Modifier Check
    renderMultipleModifierCheck(item) {
        let isMultiple = this.isItemMultiple(item.id);

        return(
            (this.state.allowMultiple && item.id !== -1) &&
            <TouchableOpacity
                onPress={() => this._onItemMultipleSwitch(!isMultiple, item.id)}
                style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 24, marginTop: 6 }}>
                <View
                    style={{
                        backgroundColor: isMultiple ? GLOBAL.COLOR.BASIC.UI_GREEN : 'white',
                        width: 22, height: 22, marginRight: 6,
                        borderWidth: isMultiple ? 0 : 2, borderColor: GLOBAL.COLOR.TEXT_LIGHT_GRAY, borderRadius: 12,
                        alignItems: 'center', justifyContent: 'center'
                    }}>
                    <View style={{ backgroundColor: 'white', width: 8, height: 8, borderRadius: 4 }}/>
                </View>

                <Text style={{ color: GLOBAL.COLOR.TEXT_GRAY, fontSize: 16 }}>
                    Can select multiple
                </Text>
            </TouchableOpacity>
        );
    }
    // endregion

    // region On Modifier Item Blurred
    _onModifierItemBlurred = (item) => {
        if (this.state.currentModifierID === item.id && item.id !== -1) {
            this.editModifier(item.id, this.state.currentModifierName, this.state.currentModifierPrice);
        }
        else this.addModifier(this.state.currentModifierName, this.state.currentModifierPrice);
    };
    // endregion

    renderSmallButton = ({
        onPress,
        locked,
        image,
        imageColor
    }) => (
        <TouchableOpacity
            disabled={locked}
            onPress={onPress}
            style={{ width: 48, height: 48, alignItems: 'center', justifyContent: 'center', opacity: locked ? 0.5 : undefined }}>
            <Image
                source={image}
                style={{ width: 24, height: 24, tintColor: imageColor }}
                resizeMode={'contain'}
            />
        </TouchableOpacity>
    )

    renderModifierItem(item, index) {
        let itemKey = `modifierItem_${item.id || index}`,
            missingInfo = (!this.state.currentModifierPrice.trim() || !this.state.currentModifierName.trim());

        return(
            <View
                key={itemKey}
                style={{
                    flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch',
                    paddingLeft: 24, paddingRight: 16,
                    borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER
                }}>
                {/* Content */}
                <View style={{ flex: 1 }}>
                    {/* Text Boxes */}
                    <View style={{ alignSelf: 'stretch', flexDirection: 'row', alignItems: 'center', flex: 1, paddingVertical: 18 }}>
                        {/* Name */}
                        <TextInput
                            ref={(comp) => this[itemKey + '_name'] = comp}
                            disabled={item['is_remove']}
                            placeholder={'[Add New Modifier]'}
                            placeholderTextColor={GLOBAL.COLOR.TEXT_LIGHT_GRAY}
                            returnKeyType="next"
                            autoCapitalize="words"
                            keyboardType="email-address"
                            autoCorrect={false}
                            editable={!this.state.isLoading}
                            isSingleInput={true}
                            style={{ outlineStyle: 'none', flex: 1, fontSize: 18 }}
                            onChangeText={(text) => this.setState({ currentModifierName: text })}
                            onSubmitEditing={(e) => this.checkDuplicateName(e.nativeEvent.text, () => this[itemKey + '_price'].focus())}
                            value={this.state.currentModifierID === item.id ? this.state.currentModifierName : item.name}
                            onFocus={() => this._onTextBoxFocused(item)}
                        />

                        <Text style={{ color: item.id === -1 ? GLOBAL.COLOR.TEXT_LIGHT_GRAY : GLOBAL.COLOR.BASIC.BLACK_TWO, marginRight: 2, marginLeft: 8 }}>
                            $
                        </Text>

                        <TextInput
                            ref={(comp) => this[itemKey + '_price'] = comp}
                            disabled={item['is_remove']}
                            prefix={'$'}
                            placeholder={'0.00'}
                            placeholderTextColor={GLOBAL.COLOR.TEXT_LIGHT_GRAY}
                            returnKeyType="done"
                            autoCapitalize="none"
                            keyboardType="numeric"
                            autoCorrect={false}
                            editable={!this.state.isLoading}
                            isSingleInput={true}
                            style={{ outlineStyle: 'none', width: 72, fontSize: 18 }}
                            onChangeText={(text) => this.setState({ currentModifierPrice: text.replace('-', '') })}
                            onSubmitEditing={() => this._onModifierItemBlurred(item)}
                            onBlur={() => this._onModifierItemBlurred(item)}
                            value={this.state.currentModifierID === item.id ? this.state.currentModifierPrice : item.price}
                            onFocus={() => this._onTextBoxFocused(item)}
                        />
                    </View>

                    {this.renderMultipleModifierCheck(item)}

                    {
                        item['is_remove'] &&
                        <View style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.7)' }}/>
                    }
                </View>

                {/* Delete/Add Button */}
                <View style={{ marginLeft: 8 }}>
                    {
                        item.id !== -1 ?
                            (
                                this.state.currentModifierID === item.id ?
                                    this.renderSmallButton({
                                        onPress: () => this.editModifier(item.id, this.state.currentModifierName, this.state.currentModifierPrice),
                                        image: require('../../images/iconLineEdit@3x.png'),
                                        imageColor: GLOBAL.COLOR.BASIC.DODGER_BLUE,
                                        locked: missingInfo
                                    })
                                    :
                                    (
                                        item['is_remove'] ?
                                            this.renderSmallButton({
                                                onPress: () => this.restoreModifier(item.id),
                                                image: require('../../images/iconLineRefresh@3x.png'),
                                                imageColor: GLOBAL.COLOR.TEXT_LIGHT_GRAY
                                            })
                                            :
                                            this.renderSmallButton({
                                                onPress: () => this.removeModifier(item.id, index),
                                                image: require('../../images/iconLineDelete@3x.png'),
                                                imageColor: GLOBAL.COLOR.BASIC.RED
                                            })
                                    )
                            )
                            :
                            this.renderSmallButton({
                                onPress: () => this.addModifier(this.state.currentModifierName, this.state.currentModifierPrice),
                                image: require('../../images/iconLinePlus@3x.png'),
                                imageColor: missingInfo ? GLOBAL.COLOR.TEXT_LIGHT_GRAY : GLOBAL.COLOR.BASIC.GREEN,
                                locked: missingInfo
                            })
                    }
                </View>
            </View>
        );
    }
    // endregion

    showModal = (currentModifierGroup) => {
        this.setState({ showModal: true, currentModifierGroup }, () => {
            this.isEdit = !!this.state.currentModifierGroup?.id;
            this.initializeValue();
        });
    }
    hideModal = () => this.setState({ showModal: false, startLoadingComp: false });

    // region MAIN RENDER FUNCTION
    render() {
        return(
            <InScreenModal visible={this.state.showModal} onDismiss={() => this.hideModal()}>
                {/* Nav Bar */}
                {this.renderNavBar()}

                {/* Content */}
                {
                    this.state.startLoadingComp ?
                        <Animatable.View
                            animation={'fadeIn'}
                            style={{ flex: 1, width: '100%', backgroundColor: 'rgba(0, 0, 0, 0.03)' }}>
                            {/* Modifier Data */}
                            <View style={{ flex: 1, width: '100%' }}>
                                <ScrollView
                                    style={{ flex: 1, width: '100%' }}
                                    contentContainerStyle={{ paddingBottom: 20 + (this.state.currentModifierGroup?.id ? 48 : 0), paddingTop: 0 }}>
                                    {/* Nam Input */}
                                    {this.renderNameInput()}

                                    {/* Item List Title */}
                                    <SectionTitle
                                        title={'Item List'}
                                        description={'Add or remove modifier items here'}
                                    />

                                    {/* Modifier List */}
                                    <View style={{ width: '100%', backgroundColor: 'white', borderTopWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER }}>
                                        {this.state.modifierList.map((item, index) => this.renderModifierItem(item, index))}
                                    </View>

                                    {/* Rule Title */}
                                    <SectionTitle
                                        title={'Rules'}
                                        description={'Set rules to control how consumers select items in this modifier group'}
                                    />

                                    {/* Rule Selection */}
                                    <View style={{ alignSelf: 'stretch', backgroundColor: 'white', borderTopWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER }}>
                                        {
                                            this.renderSwitchView(
                                                'Must select' + (this.state.mustSelect ? ` at least ${this.state.minSelect} item${this.state.minSelect > 1 ? 's' : ''}` : ''),
                                                this.state.mustSelect,
                                                this._onMustSelectSwitch,
                                                'Customers must select at least one modifier in order to add this food item to their cart. Example: "Customers must select a size for their drink, either Small, Medium or Large."',
                                                this.state.mustSelect ? () => this._onMustSelectSwitch(true, true) : () => {},
                                                {},
                                                this.state.mustSelect ? { color: GLOBAL.COLOR.BASIC.DODGER_BLUE, fontWeight: 'bold' } : {}
                                            )
                                        }

                                        {
                                            this.renderSwitchView(
                                                'Allow multiple selections' + (this.state.allowMultiple ? (this.state.maxSelect > 0 ? ` (Max ${this.state.maxSelect})` : '') : ''),
                                                this.state.allowMultiple,
                                                this._onMultipleSelectSwitch,
                                                'Customers can add multiple modifiers to this food item. Example: "Customers can add extra chicken and bacon to their burger."',
                                                this.state.allowMultiple ? () => this._onMultipleSelectSwitch(true, true) : () => {},
                                                {},
                                                this.state.allowMultiple ? { color: GLOBAL.COLOR.BASIC.DODGER_BLUE, fontWeight: 'bold' } : {}
                                            )
                                        }
                                    </View>

                                    {/* Delete Group Button */}
                                    {
                                        this.state.currentModifierGroup?.id &&
                                        <View style={{ width: '100%', borderBottomWidth: 1, borderTopWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER, alignItems: 'center', backgroundColor: 'white', marginTop: 32 }}>
                                            <TouchableOpacity
                                                onPress={() => this.goDeleteModifierGroup()}
                                                style={{ width: '100%', flex: 1, backgroundColor: 'white', alignItems: 'center', justifyContent: 'center', paddingVertical: 20 }}>
                                                <Text style={{ fontWeight: '500', color: GLOBAL.COLOR.BASIC.RED, fontSize: 18 }}>
                                                    Delete Modifier Group
                                                </Text>
                                            </TouchableOpacity>
                                        </View>
                                    }
                                </ScrollView>
                            </View>
                        </Animatable.View>
                        :
                        <LoadingView/>
                }

                {/* Cover Loading View */}
                {this.state.isLoading && <LoadingView isAbsolute={true} description={'Saving modifier group'}/>}

                {/* Toast */}
                <Toaster position={'top-center'} toastOptions={{ duration: 2000, style: { backgroundColor: 'black', color: 'white' } }} />
            </InScreenModal>
        );
    }
    // endregion
}
